import React, { ReactElement } from 'react';
import { Widget } from '@kursk/components/ui/ContentBlock/WidgetBlock/Widget/Widget';
import { WidgetGeo } from '@kursk/components/ui/ContentBlock/WidgetBlock/WidgetGeo/WidgetGeo';
import { IWidgetType } from "@common/redux/types/event";

interface IProp {
  widget: IWidgetType;
  index: number;
}

export const WidgetBlock = ({ widget, index }: IProp): ReactElement => {
  const { entityDescription } = widget

  const renderWidget = () => {
    const { type, code } = widget;
    if (type === 'place' || type === 'article' || type === 'event' || type === 'touristRoute' || type === 'code') {
      return (
        <Widget
          data={widget[type]}
          type={type}
          entityDescription={entityDescription}
          code={code}
          index={index}
        />
      );
    }
    if (type === 'manual') {
      return (
        <WidgetGeo
          data={widget[type]}
        />
      );
    }
    return null;
  };
  return renderWidget();
};
